import { actions } from './actions'

const initialState = {
  productosGenericosBocetos: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosGenericosBocetosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTO_GENERICO_BOCETO_LOAD_REQUESTED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: true },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_LOAD_SUCCEEDED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_LOAD_FAILED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_INSERT_REQUESTED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: true, error: '' },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_INSERT_SUCCEEDED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          data: [...state.productosGenericosBocetos.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_INSERT_FAILED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          loading: false,
          error: action.error,
        },
      }

    case actions.PRODUCTO_GENERICO_BOCETO_UPDATE_REQUESTED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: true, error: '' },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updated = state.productosGenericosBocetos.data.map(bocetos => {
        if (bocetos.id === action.payload.id) {
          return action.payload
        }
        return bocetos
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          data: updated,
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_UPDATE_FAILED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_REQUESTED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: true, error: '' },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updatedpst = state.productosGenericosBocetos.data.map(posicion => {
        if (posicion.id === action.payload.id) {
          return action.payload
        }
        return posicion
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          data: updatedpst,
          loading: false,
          error: '',
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_POSICION_UPDATE_FAILED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          loading: false,
          error: action.error,
        },
      }

    case actions.PRODUCTO_GENERICO_BOCETO_DELETE_REQUESTED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: true },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_DELETE_SUCCEEDED:
      return {
        ...state,
        productosGenericosBocetos: {
          ...state.productosGenericosBocetos,
          loading: false,
          data: state.productosGenericosBocetos.data.filter(
            productosGenericosBocetos => productosGenericosBocetos.id !== action.id,
          ),
        },
      }
    case actions.PRODUCTO_GENERICO_BOCETO_DELETE_FAILED:
      return {
        ...state,
        productosGenericosBocetos: { ...state.productosGenericosBocetos, loading: false },
      }

    default:
      return state
  }
}
